module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("CHAPTER 1")])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("“T")])])])]), _vm._v("he terrifying dreams started two nights ago.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Dr. Claire Cantwell listened carefully as Nick Jensen, code name Lightning, wheeled his sleek Jag down Pennsylvania Avenue. The warm May weather had brought lunchtime crowds pouring out of the federal buildings that lined the broad avenue. Yet Claire didn’t so much as glance at the people crowding into outdoor cafes or lined up at street vendor carts. Her attention remained riveted on the man at her side.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Tall, tanned and tawny-haired, Nick served as special envoy to the president. The title was one of those empty honorifics spun up for a wealthy "), _c('a', {
    attrs: {
      "id": "page2"
    }
  }), _vm._v("campaign contributor decades ago. Only a handful of Washington insiders knew the position served as a facade for Nick’s real job—director of OMEGA, an ultrasecret government agency whose operatives were activated only at the direction of the president.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("One of them had just been activated. Nick had swung by her office a few moments ago on his way to the White House. Claire Cantwell, code name Cyrene, was getting briefed on her mission on the fly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A psychologist by profession, Claire had made a painful transition into the grim world of forensic psychology and hostage negotiation after her husband’s kidnapping and brutal murder almost six years ago. That expertise stood her in good stead during the dangerous and highly secret ops she worked as an undercover operative for OMEGA.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("This mission apparently would draw more on her skills as a psychologist than a secret agent. Still trying to assimilate the facts surrounding the president’s abrupt cancellation of a goodwill swing through Central America, due to his teenage daughter’s terrifying nightmares, Claire probed for details.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Did they give you any information about the nature of the nightmares?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Only that they hit suddenly, late at night. Or rather, early in the morning. Around three or four a.m.”")])]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“That’s when most dreams occur,” she acknowledged. “During REM—rapid eye movement—sleep. That normally takes place in the latter stages of the sleep cycle.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“The girl woke screaming and soaked in sweat,” Lightning related. “The first night, the physician accompanying the presidential party thought she’d simply overdone it while touring schools and special events. He gave her a mild sedative to help her sleep. The second night, the visions were evidently so real, so terrifying, that the president decided to bring her home. He’s worried sick about her.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Understandable. She’s his only child.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His only immediate family, in fact. John Jefferson Andrews had lost his wife to cancer when he was a charismatic young governor. Since then he’d balanced the demands of his political career against the needs of his daughter.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("That much was well-known. What hadn’t been made quite so public was that Andrews’s party put enormous pressure on him to run for president. He’d turned them down repeatedly, and only threw his hat in the ring after his supporters convinced him Washington needed an infusion of fresh blood.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It did. Desperately.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Andrews’s determination to clean house hadn’t made him popular with certain career bureaucrats "), _c('a', {
    attrs: {
      "id": "page4"
    }
  }), _vm._v("and Beltway bandits, however. He’d taken office in January. Now, just four months later, noisy grumbling could be heard in the halls of congress and various federal departments.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“The president asked for you personally,” Lightning said as he pulled up to the first White House security checkpoint. “You impressed both him and his daughter when you briefed them on the emotional and psychological stresses unique to the Washington environment.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’ll certainly do whatever I can to help, although I haven’t had a great deal of experience in adolescent psychology.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("whap-whap-whap")])]), _vm._v(" of a helicopter passing low overhead almost drowned her out. By the time Claire and Lightning cleared the subsequent checkpoints and walked out to the heliport, Marine One was touching down.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The steps lowered and the president emerged first. Lean and fit and boyishly handsome, John Andrews had captured the public’s imagination with his energy and obvious devotion to his daughter. Both showed as he turned to help the teenager descend.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Claire studied the dark-haired young woman as she crossed the lawn with her father. Her body language spoke volumes. Shoulders hunched, she kept her head down and avoided looking at the "), _c('a', {
    attrs: {
      "id": "page5"
    }
  }), _vm._v("group who’d turned out to welcome home the presidential party. The only sign of a normal fourteen-year-old was the iPod poking out of the pocket of her bright red jacket and the white earbuds looped around her neck.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The president gave Lightning’s hand a quick shake before turning to Claire. “Thanks for rearranging your schedule for us, Dr. Cantwell.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You’re welcome, sir.” She returned his firm handshake before shifting her gaze to the teenager. “It’s good to see you again, Stacy.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The girl nodded and murmured a greeting.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Your father thought it might help you to talk about what happened during the trip. I’ll be happy to chat, if that’s okay with you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The teen lifted her head then, and shocked Claire with the dark circles under her eyes. In a few short days, the smiling, happy young girl who’d waved to photographers before boarding Air Force One had acquired a haunted look.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I guess.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The president laid an arm across his daughter’s shoulders. “Why don’t you take Dr. Cantwell up to the living quarters, Stace? I need to go to the office and make a few calls.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Okay.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Claire started to follow the teen, but caught sight of a familiar figure descending the steps of "), _c('a', {
    attrs: {
      "id": "page6"
    }
  }), _vm._v("Marine One. Her pulse gave a sudden kick and a wry smile tipped her lip.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Colonel Luis Esteban made Antonio Banderas look like something the cat dug up.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She should be conditioned to the impact of his curling black hair, bronzed skin, silky mustache and come-hither smile, all wrapped up in six foot two inches of solid male. She and Luis had worked several missions together. More to the point, they’d been lovers for almost a year now. Between her practice and periodic missions for OMEGA, and his frequent trips back to his own country, they saw each other often enough to maintain the sizzle, but "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("not")])]), _vm._v(" so often that the mere sight of him should send heat racing through her veins and clench the muscles low in her belly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("They’d first met years ago, when he served as chief of security for the Central American nation of Cartoza. In that capacity, he’d worked an op with Maggie Sinclair, another now-retired OMEGA agent. The drop-dead-gorgeous Esteban had turned up in Washington some months later, fully intending to follow up on the attraction that had sparked between him and Maggie.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("When he found her involved with the man she later married, Luis claimed she’d broken his heart. Maggie knew better, as she laughingly informed Claire when Luis’s roving eye descended on the "), _c('a', {
    attrs: {
      "id": "page7"
    }
  }), _vm._v("quiet, self-contained psychologist. The colonel’s blatant attempts to get Claire into his bed had amused her at first. Then slowly, inevitably, they’d reawakened the sexual appetites that had gone into hibernation after her husband’s murder. The man was as skilled a lover as he was persistent.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Esteban now served as Cartoza’s ambassador to the U.S. As such, he’d done most of the advance work for President Andrews’s now canceled goodwill trip. Claire knew how many hours he’d put into preparing for it, and guessed he would shoulder a heavy dose of responsibility over its abrupt termination.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Would you wait just a moment, Stacy? I’d like to talk to Ambassador Esteban.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She’d taken only a few steps across the lawn before Luis drew aside with another disembarking passenger. Claire recognized sandy-haired Tom Fogerty, the president’s chief of staff. Whipcord lean and intense, he was one of the few Washington insiders retained by President Andrews to facilitate his administration’s transition. And by the sound of it, Fogarty was not at all happy with the cancellation of the Central American trip.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I don’t know when we’ll reschedule,” he told Luis, impatiently shifting his briefcase from hand to hand. “To tell the truth, Mr.Ambassador, Cartoza isn’t real high on my list of priorities right now.”")])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“It should be,” Luis shot back. “We are the United States’s strongest ally in that region.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yeah, well, maybe if you’d managed security a little better in your country, we wouldn’t have had to cut our visit short.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Luis’s jaw locked. Even from several yards away, Claire recognized the warning signs.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I will tell you one more time, my friend,” he said slowly, dangerously. “Stacy Andrews did not eat or drink anything that wasn’t first tested by both your people and mine.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Something caused those nightmares. I still think we’ll find they were drug-induced.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“The blood test showed no evidence of hallucinogens. The president informed me of that himself.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m sure he’ll want the tests rerun, now that we’re back in the States.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The implication was as insulting as Fogerty’s sneer.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("When Luis narrowed his eyes and gave a low hiss, the politician took a quick step back. Hastily, Claire intervened.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’d like to see those test results,” she said with cool authority. “I’ll obtain the necessary privacy release. If you would, Mr. Fogerty, please ask the president’s physician to fax them to my office. Here’s my card.”")])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Right.” Keeping a wary eye on Luis, Fogerty pocketed the business card she retrieved from her purse. “And I’ll need to know your assessment of Stacy’s condition.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m sorry, that’s privileged information.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Not when your patient is the daughter of the president.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“She’s not my patient. We’re merely going to chat.” Claire’s normally soft voice was laced with steel. “With Stacy’s permission, I may tell her father what we talked about. But he’s the "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("only")])]), _vm._v(" one I’ll consult or release information to without her specific consent.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Fogerty jerked his head in a quick nod and walked away. Luis followed his progress with narrowed eyes.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“He is an officious bureaucrat, that one. The next time he insults me or my country, he will find himself eating his teeth for breakfast.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("For all Claire’s training and skill at handling people, she’d yet to learn how best to deal with Luis when something roused his fierce, untempered masculinity. His surge of testosterone at moments like this reflected his passion and his proud Latin heritage.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("On a deep instinctive level, she appreciated his tough machismo. He was a man anyone could rely on in a tight situation. She should know. She’d "), _c('a', {
    attrs: {
      "id": "page10"
    }
  }), _vm._v("done exactly that several times during the missions they’d worked together.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("On a more civilized level, she wanted to calm and soothe and direct his uncompromising maleness into somewhat less combative channels. The eternal female response, when dealing with someone like Luis, she acknowledged with a wry inner smile.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Can you come for dinner?” she asked quietly. “I’d like your take on what happened.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His expression altered. The heat didn’t leave his dark eyes and the testosterone was still zinging through the air, but this time both were directed at her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Of course, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("mi querida")])]), _vm._v(". I’ll bring the wine. Seven o’clock?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Seven’s good.”")])]), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("Trailed by her Secret Service detail, Stacy Andrews escorted Claire up a flight of stairs in the Executive Residence. The protective agents remained in the hall outside while the girl ushered Claire into a suite of sunny rooms that overlooked the South Lawn.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The suite blended early American history with the distinctive stamp of a lively teenager. A funky lamp with a leopard-print shade sat atop what looked like a genuine Chippendale tea table. Posters of the "), _c('a', {
    attrs: {
      "id": "page11"
    }
  }), _vm._v("Jonas Brothers decorated one wall, a Frederic Church landscape hung on another. A laptop and iPod player occupied a place of honor on an early American slant-lid desk. D.C. schools let out in mid-May for the summer, so there were no backpacks or textbooks scattered around, but Claire noted with approval plenty of teen magazines and paperbacks.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Growing up the daughter of a popular and gregarious governor had instilled Stacy Andrews with social graces beyond her years. Forcing herself to shed some of her reserve, she played the perfect hostess.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Please, make yourself comfortable, Dr. Cantwell.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Claire chose the oversize sofa, angled to face a wall-hung plasma TV.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Would you like something to drink?” Stacy asked politely. “Tea? Coffee? A Diet Coke?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“A Diet Coke would be great.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A small army of staff catered to the First Family’s needs, but the teen kept a private stash of goodies in her suite’s minikitchen. She poured two soft drinks into ice-filled glasses, then filled a bowl with cheesy Corn Curls.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“These are my favorite munchies,” she confided as she positioned the bowl between them on the sofa. “Dad’s, too.”")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Luckily, she’d provided linen napkins with the snack. Claire nibbled on a few morsels and dusted the orange residue from her fingers before taking a sip of cola. She didn’t push the subject foremost on both their minds. Instead, she and Stacy chatted idly about other favorite foods and the latest "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("High School Musical")])]), _vm._v(" movie. The subject of the teen’s plans for the summer led to an awkward pause.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m going to camp,” she said slowly, twisting a strand of dark brown hair around two fingers. “After camp, I was supposed to accompany Dad on another goodwill tour, this one to Asia. I don’t know if he’ll want to take me after…after what happened in Cartoza.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("did")])]), _vm._v(" happen, Stacy?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I don’t know! I mean, I was having fun. I met lots of kids my own age and went to a village fiesta and got to swim with the dolphins at a marine life preserve. Then I had these…these awful dreams.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Can you describe them for me?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“There were people. Lots of people dressed in kind of weird clothes.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Weird how?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Old-fashioned, I guess you could call it. And real plain, like they were farmers or something. Some of the women had kerchiefs on their heads. At first they were just standing there, staring at me. Then they…Then they…”")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She twisted the strand of hair into a tight spiral. Her breathing sped up. Carefully, Claire watched these visible signs of distress.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“They started crowding closer and closer,” Stacy said in a small, scared voice, “until I was surrounded.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She swallowed. Her eyes took on a haunted look that accented the dark shadows under them.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Then their faces start falling off,” she whispered, pushing out each ragged syllable. “The flesh melted away, until they were just skulls with empty eyes. All of them. Just skeletons. Surrounding me. Reaching for me. Like…Like I was going to die and they wanted to drag me into the grave with them!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She ended on a note of rising panic. Claire anchored her with a calm observation.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Skeletons quite often appear in dreams, but they don’t necessarily symbolize physical death.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Hope replaced the burgeoning fear in the girl’s eyes. “They don’t?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No. In fact, some analysts think they represent life, not death. It could be your subconscious telling you to stop, take a breath, focus on the positive things around you, instead of the negative. Which must be kind of hard to do when you’re living in a fishbowl,” Claire added shrewdly, “and "), _c('a', {
    attrs: {
      "id": "page14"
    }
  }), _vm._v("you see your father’s critics on the evening news. It must hurt to hear them question his leadership.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“It does! I hate it when people criticize him. They did it back home, too, when he was governor, but they’re so much meaner here.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Claire didn’t doubt that. Andrews was playing in the big league now.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Did you have dreams like this back home?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No, never!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Tell me what books you’ve been reading lately. What Web sites you go to, the movies you watch.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("With her bright red jacket, jeans and Mary Janes, Stacy Andrews didn’t give the appearance of being into Goth or horror, but Claire knew appearances could be very deceptive. Nothing the girl related seemed likely to have implanted the hideous images she’d described, however.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“How about caffeine?” She tapped the frosted glass. “Do you usually have a soft drink before bed?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No. Dad says they’re not good for me and wants me to limit myself to one or two during the day.” Her eyes pleaded with Claire for another explanation. “The dreams really freaked me out, Dr. Cantwell. What else could have caused them?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Well, it could have been the stress of the trip, "), _c('a', {
    attrs: {
      "id": "page15"
    }
  }), _vm._v("although threatening dreams such as the ones you’ve described can result from any number of causes.” Lifting a hand, she ticked off a quick list. “Anxiety, illness, loss of a loved one, excessive alcohol consumption, reaction to a drug, sleeping disorders, or even an inherited tendency toward nightmares.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Dad never mentioned having horrible dreams like this, and he’s got a lot more stress than I do.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“How about your mom?” Claire asked gently. “You went through a rough time when you lost her. Do you still miss her?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Every day. But…” She worried her lower lip with her teeth for a moment. “It scares me, Dr. Cantwell. Sometimes I have to think real hard to remember what she looked like.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“That’s a natural part of healing.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As Claire knew all too well.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“We may not keep their faces or the sound of their voices in our heads, but we keep them here.” She laid a palm over her heart, reminded vividly of her own torturous journey. “You don’t need to feel guilty for going on with your life, Stacy.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I don’t. At least, I don’t think I do.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("They talked for a little while longer, and Claire heard nothing that suggested a troubled or deeply disturbed teen.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Tell you what,” she said when they finished. “I’ll do some research and get back to you. In the meantime, try to go to bed the same time each night—even on weekends—to reset your sleep cycle. A warm, relaxing bath before you hit the sheets might also help. Also a good thirty-minute workout, if you exercise at least four to five hours before bedtime.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I can do that.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I can’t promise you won’t have these dreams again,” Claire cautioned. “If you do, call me and I’ll come over. Or you can come to my office. We’ll talk you through them and try to understand what they’re telling you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Thanks, Dr. Cantwell. I’m…I’m not so scared now.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Good girl. Do you want me to speak to your father about our discussion? I won’t, if you’d rather not.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Sure, you can tell Dad. I’ll talk to him, too, and tell him what you said.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Stacy’s Secret Service detail remained on duty in the hall while a staff member escorted Claire to the West Wing.")])]), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("She departed the White House a half hour later, leaving behind a somewhat reassured teenager and a still very worried father. Another staff "), _c('a', {
    attrs: {
      "id": "page17"
    }
  }), _vm._v("member drove her back to her office on K Street. Since her very efficient office manager had cleared her schedule after Lightning’s call, Claire decided to beat the traffic out of the city and dictate notes of her session with Stacy Andrews at home.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As she drove across the 14th Street Bridge and headed for Alexandria, her thoughts swung between the frightened teenager she’d spent the afternoon with, and the enticing, demanding, occasionally exasperating but always intriguing man she would spend the evening with.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Luis could fill in more details concerning Stacy Andrews’s activities while in Cartoza. With a shiver of sensual anticipation, Claire decided he could also make up for the long hours she’d put in at work while he was gone.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She loved her profession. Helping someone through pain or confusion or despair gave her a deep sense of giving back to the world. Her client list kept her extremely busy between the missions she worked for OMEGA. Very often, Claire brought casework home with her, as she had tonight.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She had a large number of friends and acquaintances, as well. Socializing with them and with her tight circle of fellow agents required skilled juggling. Luis had added another dimension to the life Claire had carved out for herself.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And of all the demands on her time and energy, she acknowledged with another ripple of anticipation, Colonel Luis Esteban required the most personal attention.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b6c9128","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter01.vue
// module id = 66
// module chunks = 0